import { css } from 'styled-components';
import { spaceMixin } from '../spaceMixin';

/** @class PropertyCardBadgeAreaMixin */
/** @method */
export var PropertyCardBadgeAreaMixin = function PropertyCardBadgeAreaMixin(props) {
  return css(["display:grid;grid-auto-flow:column;grid-column-gap:", ";align-items:start;"], spaceMixin(0.5)(props));
};